var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcGraphCompare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 8.99805C3 8.03154 3.78351 7.24805 4.75 7.24805H5.75C6.71649 7.24805 7.5 8.03154 7.5 8.99805V18.998C7.5 19.9645 6.71648 20.748 5.75 20.748H4.75C3.78352 20.748 3 19.9645 3 18.998V8.99805ZM4.75 8.74805C4.61193 8.74805 4.5 8.85998 4.5 8.99805V18.998C4.5 19.1361 4.61192 19.248 4.75 19.248H5.75C5.88808 19.248 6 19.1361 6 18.998V8.99805C6 8.85998 5.88807 8.74805 5.75 8.74805H4.75Z",
    fill: "#76B72A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 5C10 4.0335 10.7835 3.25 11.75 3.25H12.75C13.7165 3.25 14.5 4.03352 14.5 5V18.9995C14.5 19.966 13.7165 20.7495 12.75 20.7495H11.75C10.7835 20.7495 10 19.966 10 18.9995V5ZM11.75 4.75C11.6119 4.75 11.5 4.86192 11.5 5V18.9995C11.5 19.1376 11.6119 19.2495 11.75 19.2495H12.75C12.8881 19.2495 13 19.1376 13 18.9995V5C13 4.86192 12.8881 4.75 12.75 4.75H11.75Z",
    fill: "#76B72A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 11.998C17 11.0317 17.7834 10.248 18.75 10.248H19.75C20.7166 10.248 21.5 11.0317 21.5 11.998V18.998C21.5 19.9646 20.7165 20.748 19.75 20.748H18.75C17.7835 20.748 17 19.9646 17 18.998V11.998ZM18.75 11.748C18.612 11.748 18.5 11.86 18.5 11.998V18.998C18.5 19.1361 18.6119 19.248 18.75 19.248H19.75C19.8881 19.248 20 19.1361 20 18.998V11.998C20 11.86 19.888 11.748 19.75 11.748H18.75Z",
    fill: "#76B72A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGraphCompare);
export default __webpack_public_path__ + "static/media/ic-graph-compare.b2f6f76314b22af36d9ec3ee7f67237e.svg";
export { ForwardRef as ReactComponent };